export const getMilimetersFromPixels = (pixels: number, dpi: number = 300) => {
  const inches = pixels / dpi; // Convert pixels to inches
  const millimeters = inches * 25.4; // Convert inches to millimeters
  return millimeters;
};
